var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "multiselect",
        {
          attrs: {
            name: "projects",
            options: _vm.types,
            placeholder: "Выберите причину",
            "track-by": "id",
            label: "title",
            searchable: true,
            multiple: false,
          },
          on: { input: (t) => {} },
          model: {
            value: _vm.$editNewOrder.reject_type_id,
            callback: function ($$v) {
              _vm.$set(_vm.$editNewOrder, "reject_type_id", $$v)
            },
            expression: "$editNewOrder.reject_type_id",
          },
        },
        [
          _c("template", { slot: "noResult" }, [
            _vm._v("Вариант не найден, запишите свой"),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.$editNewOrder.reject_type_id?.id === 0
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.$editNewOrder.reject_comment,
                expression: "$editNewOrder.reject_comment",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Укажите свою причину отказа" },
            domProps: { value: _vm.$editNewOrder.reject_comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(
                  _vm.$editNewOrder,
                  "reject_comment",
                  $event.target.value
                )
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }